module.exports = __webpack_public_path__ + "img/23_102.91219116.png";